import { Table } from 'react-bootstrap';
import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import FileInput from '../components/forms/FileInput';
import Icon from '../components/forms/Icon';
import CloseIcon from '../images/close_red.png';
import { downloadFile } from '../actions/helper';

class InstallationServiceAttachments extends React.Component {
  render() {
    const {
      translate,
      onAttachmentsAdded,
      installationAttachments,
      session: { isAdmin = false },
      onNotNewlyAddedFileToEditState,
      isEditState,
      onAttachmentsRemoved,
    } = this.props;

    const formatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) {
        return '0 Bytes';
      }
      const k = 1024;
      const dm = decimals < 0
        ? 0
        : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
    };

    const downloadFileLocally = (file) => {
      if (isEditState && onNotNewlyAddedFileToEditState(file)) {
        downloadFile(file.id, '/installationdocument/order/file');
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(file);
        link.download = file.name;
        link.click();
      }
    };

    return (
      <div>
        <Table bordered>
          <thead className="table-head">
            <tr>
              <th>{translate('service_installation.attachment_title')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div>
                  <div className="col-sm-6">
                    <FileInput
                    className="file-select-button vertical-middle form-button form-input-shadow"
                    multiple
                    onClick={(event) => {
                      event.currentTarget.value = null;
                    }}
                    onChange={onAttachmentsAdded}>
                      {translate('service_installation.add_a_new_file')}
                    </FileInput>
                  </div>
                  <Table bordered>
                    <thead className="device-table-header">
                      <tr>
                        <th>{translate('service_installation.column.file')}</th>
                        <th>{translate('service_installation.column.size')}</th>
                        <th style={{ width: '4%' }} />
                      </tr>
                    </thead>
                    <tbody>
                      {installationAttachments.map((file) => (
                        <tr key={file.name}>
                          <td>
                            <a className="text-6 normal-color link"
                               onClick={() => downloadFileLocally(file)}>
                              {file.name}
                            </a>
                          </td>
                          <td>
                            <span className="text-6 normal-color">{formatBytes(file.size)}</span>
                          </td>
                          <td>
                            {isAdmin === false && onNotNewlyAddedFileToEditState(file) && isEditState
                              ? ''
                              : (
                                <Icon
                                className="file-select-remove-button form-input-file-list-item-remove form-input-clickable"
                                src={CloseIcon}
                                onClick={() => onAttachmentsRemoved(file)} />
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);
  return {
    currentLanguage: activeLanguage?.code || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceAttachments);
